"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentItem = /** @class */ (function () {
    /**
    * Base class representing content item type. All content type models need to extend this class.
    * @constructor
    */
    function ContentItem(config) {
        this._config = config;
    }
    return ContentItem;
}());
exports.ContentItem = ContentItem;
var ContentItemSystemAttributes = /** @class */ (function () {
    function ContentItemSystemAttributes(data) {
        Object.assign(this, data);
    }
    return ContentItemSystemAttributes;
}());
exports.ContentItemSystemAttributes = ContentItemSystemAttributes;
var Link = /** @class */ (function () {
    function Link(data) {
        Object.assign(this, data);
    }
    return Link;
}());
exports.Link = Link;
var RichTextImage = /** @class */ (function () {
    function RichTextImage(data) {
        Object.assign(this, data);
    }
    return RichTextImage;
}());
exports.RichTextImage = RichTextImage;
var RichTextItemDataType;
(function (RichTextItemDataType) {
    RichTextItemDataType["Item"] = "item";
})(RichTextItemDataType = exports.RichTextItemDataType || (exports.RichTextItemDataType = {}));
//# sourceMappingURL=item-models.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/models/item/item-models.js